import React, { useState } from 'react';
import type { Match } from '@gin-betting/match';

import MarketsTabConfigsContext from './MarketsTabConfigsContext';

const MarketsTabConfigsCtx: React.FC = ({ children }) => {
    const [
        marketsTabConfigsBySport,
        setMarketsTabConfigsBySport,
    ] = useState<Match.MarketTabConfigBySport>({});

    return (
        <MarketsTabConfigsContext.Provider
            value={{
                marketsTabConfigsBySport,
                setMarketsTabConfigsBySport,
            }}
        >
            {children}
        </MarketsTabConfigsContext.Provider>
    );
};

export default MarketsTabConfigsCtx;
